module.exports = __webpack_public_path__ + "img/buying-power.413d172b.svg";